import React from 'react'
import { useParams } from "react-router-dom";
import SideNavBar from '../../components/headers/sidenavbar/SideNavBar';
import UserData from '../../components/headers/topnavbar/UserData';
import AddChapterChild from '../../components/teamleaderchild/AddChapterChild';

function AddChapter() {
    let { id } = useParams();
    return (
        <div>
            <div id="wrapper">
                <SideNavBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <UserData />
                        <div className="container-fluid">
                            <AddChapterChild id={id}/>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}

export default AddChapter
